'use client';

import * as React from 'react';
import ChangePasswordModalContent from '@/app/dashboard/staff-settings/all-staff/components/change-password-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function ChangePasswordModal(): React.JSX.Element {
  const { modal } = useAppSelector(getUi);

  return (
    <ModalLayout title="Change Password" isOpen={modal?.open === ModalDrawer.CHANGE_PASSWORD}>
      <ChangePasswordModalContent />
    </ModalLayout>
  );
}
